import { FC, CSSProperties } from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

export type StatusTransitionProps = {
  className?: string;
  style?: CSSProperties;
};

const useStyles = makeStyles(
  theme => ({
    root: {
      width: 330,
      height: 11,
      color: theme.palette.secondary.dark,
    },
  }),
  { name: 'StatusTransition' },
);

export const StatusTransition: FC<StatusTransitionProps> = ({
  className,
  style,
}) => {
  const classes = useStyles();
  return (
    <svg
      className={clsx(classes.root, className)}
      style={style}
      viewBox="0 0 330 11"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.71436 5.54761H319.036"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="1 6"
      />
      <path
        d="M324.813 1.12834C324.487 0.806481 323.963 0.80648 323.637 1.12834C323.306 1.45548 323.306 1.99003 323.636 2.31753L326.181 4.83701C326.576 5.22832 326.576 5.86689 326.181 6.2582L323.636 8.77768C323.306 9.10519 323.306 9.63973 323.637 9.96688C323.963 10.2887 324.487 10.2887 324.813 9.96688L328.566 6.25897C328.962 5.86749 328.962 5.22772 328.566 4.83625L324.813 1.12834Z"
        fill="currentColor"
      />
    </svg>
  );
};
